import { useAccountDetails } from '@api/hooks/useAccounts';
import { toastError } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext.tsx';
import { Loader } from '@gurupay/gp-ui-library';
import { useTransactionDetail } from '@hooks/useTransactionDetail';
import { nullsToUndefined } from '@utils/utils';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

export const OperationLoader = ({ children }: { children: React.ReactNode }) => {
	const params = useParams();
	const { t } = useTranslation();
	const { selectedProfile } = useBankProfile();
	const {
		data: operation,
		isLoading,
		failureCount,
	} = useTransactionDetail((params.id as string) ?? '');
	const { data: selectedAccount, isLoading: isAccountLoading } = useAccountDetails(
		operation?.account_uuid,
	);

	useEffect(() => {
		if (failureCount === 1) {
			toastError(t('payments.errors.notFound'));
		}
	}, [failureCount, t]);

	if (selectedProfile && !isLoading && !isAccountLoading && !operation) {
		return <Navigate replace to="/operations" />;
	}

	if (isLoading || isAccountLoading || !operation) {
		return (
			<div className="flex items-center justify-center h-[500px]">
				<Loader />
			</div>
		);
	}

	return (
		<>
			{React.Children.map(children, (child) =>
				React.isValidElement(child)
					? React.cloneElement(child as React.ReactElement<any>, {
							operation: nullsToUndefined(operation),
							selectedAccount,
						})
					: child,
			)}
		</>
	);
};
